// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCPnGrdymEJblkRCr_JYDR9mD9Ow-IgV2g",
  authDomain: "cutnconnect-3c3be.firebaseapp.com",
  projectId: "cutnconnect-3c3be",
  storageBucket: "cutnconnect-3c3be.appspot.com",
  messagingSenderId: "519608667468",
  appId: "1:519608667468:web:27fa29c5d425b2af0e53e9",
  measurementId: "G-STHHBNMN69"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export const db = getFirestore(app);